import { MONEY_DECIMALS as DECIMAL_PRECISION, roundMoney as sharedRoundMoney,
  resolveTip as sharedResolveTip, type TipInputMode } from 'shared-models/browser';

let wholeAmounts = false;
export let MONEY_DECIMALS = DECIMAL_PRECISION;

export function configurePosMoneyRounding(enabled: boolean): void {
  wholeAmounts = enabled;
  MONEY_DECIMALS = enabled ? 0 : DECIMAL_PRECISION;
}

export function roundMoney(value: number, roundAmounts = wholeAmounts): number {
  return sharedRoundMoney(value, roundAmounts);
}

export function resolveTip(mode: TipInputMode | null | undefined, value: number | null | undefined, base: number, roundAmounts = wholeAmounts): number {
  return sharedResolveTip(mode, value, base, roundAmounts);
}

export function formatMoney(value: number, roundAmounts = wholeAmounts): string {
  return roundMoney(value, roundAmounts).toFixed(roundAmounts ? 0 : DECIMAL_PRECISION);
}

/** Like formatMoney but drops the decimal when it's .0 (e.g. 5.0 → "5", 5.5 → "5.5") */
export function formatMoneyCompact(value: number, roundAmounts = wholeAmounts): string {
  const fixed = formatMoney(value, roundAmounts);
  return fixed.endsWith('.0') ? fixed.slice(0, -2) : fixed;
}

const LTR_ISOLATE = '\u2066';
const POP_DIRECTIONAL_ISOLATE = '\u2069';

// Wrap a negative amount in an LTR isolate so the minus stays left of the digits in RTL (bidi fix).
export function isolateAmountLtr(formatted: string): string {
  return formatted.startsWith('-') ? `${LTR_ISOLATE}${formatted}${POP_DIRECTIONAL_ISOLATE}` : formatted;
}
